// PreviewRedirect.jsx — mirror of AffiliateRedirect, separate storage key. used for tracking the conversion from code demo
import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const VALID_SLUG = /^[a-zA-Z0-9-]{8,64}$/;
const TTL_DAYS = 90;

export default function PreviewRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    
    console.log('PreviewRedirect search:', window.location.search, '| b:', searchParams.get('b'));
    const normalized = (slug || '').trim();
    if (VALID_SLUG.test(normalized)) {
      const existing = localStorage.getItem('revfer_preview_ref');   // first-touch wins
      if (!existing) {
        const attribution = {
          slug: normalized,
          business_name: (searchParams.get('b') || '').slice(0, 120) || null,
          vertical: (searchParams.get('v') || '').slice(0, 60) || null,
          captured_at: new Date().toISOString(),
          expires_at: new Date(Date.now() + TTL_DAYS * 86400000).toISOString()
        };
        try {
          localStorage.setItem('revfer_preview_ref', JSON.stringify(attribution));
          const maxAge = TTL_DAYS * 86400;
          document.cookie = `revfer_preview_ref=${normalized}; Max-Age=${maxAge}; Path=/; SameSite=Lax; Secure`;
        } catch (e) {
          console.warn('localStorage unavailable for preview attribution', e);
        }
      }
    }
    navigate('/', { replace: true });
  }, [slug, navigate, searchParams]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2 }}>
      <CircularProgress size={28} />
      <Typography variant="body2" color="text.secondary">Loading...</Typography>
    </Box>
  );
}